/* @flow */

import React, { useContext } from "react";
import { SuccessView } from "@crossroads/shop-views";
import { AnalyticsContext } from "@crossroads/analytics";
import { useClient } from "entrypoint/shared";
import { OrderData } from "state/data";
import { useData } from "crustate/react";
import { load as loadOrder } from "state/order";
import useFormat from "helpers/hooks/use-format";
import { useTranslate } from "@awardit/react-use-translate";
import CheckIcon from "icons/checkmark-success.svg";

const Success = (): React$Node => {
  const orderData = useData(OrderData);
  const { formatPrice } = useFormat();
  const analytics = useContext(AnalyticsContext);
  const t = useTranslate();

  return (
    <SuccessView
      orderData={orderData}
      useClient={useClient}
      analytics={analytics}
      formatPrice={formatPrice}
      additionalField="PHONE"
      loadOrder={loadOrder}
      CheckIcon={<CheckIcon aria-label={t("ICONS.CHECK")} style={{ color: "#fff" }} />}
    />
  );
};

export default Success;
